var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmail = function SvgEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.999 13.948a.835.835 0 0 1-.59-.244L4.953 7.247a.333.333 0 0 1 .188-.566 1.31 1.31 0 0 1 .192-.014h13.334c.064 0 .128.004.191.014a.333.333 0 0 1 .187.566l-6.457 6.457a.835.835 0 0 1-.59.244zm7.856-6.067a.121.121 0 0 1 .07.007A.12.12 0 0 1 20 8v8a1.333 1.333 0 0 1-1.333 1.333H5.333A1.333 1.333 0 0 1 4 16V8a.121.121 0 0 1 .075-.11.12.12 0 0 1 .133.025l4.133 4.134a.167.167 0 0 1 0 .236L4.98 15.647a.5.5 0 0 0 .707.707l3.362-3.362a.167.167 0 0 1 .236 0l1.42 1.418a1.833 1.833 0 0 0 2.593 0l1.419-1.42a.168.168 0 0 1 .182-.036c.02.009.039.021.054.037l3.362 3.362a.498.498 0 0 0 .713.005.5.5 0 0 0-.006-.713l-3.362-3.362a.167.167 0 0 1 0-.236l4.133-4.133a.121.121 0 0 1 .063-.033z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "email.4ad7dfa04cae6116dbbabd5e08842428.svg";